import axios from "axios";

const state = {};
const getters = {};
const actions = {
    deleteMerchantCustomer: async ({commit}, hashedWebsiteId) => await axios.delete(`/agency/merchant/customers/website/${hashedWebsiteId}`),
};
const mutations = {};

const merchant = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export default merchant;
